import { Injectable } from '@angular/core';
import { LoginUser, MedicalProvider, Organisation } from '../models/commonmodel';

import { requestmore } from '../components/request-more-details/request-more-details.component';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, Observable, of, Subject, takeUntil } from 'rxjs';
import { environment } from '@environments/environment';
import { MemberInsurerServiceService } from './member-insurer-service.service';
import { addAgent, addAgentPayload, additionalInfoRequest, AddMasterprovider, addMemberResponse, addProviderPayload, adminAgentsData, adminInsurerStack, AdminInsurerStackItem, adminRegister, allAdminInsurerResponse, allAdminProviderResponse, allAgentslistResponse, allCounts, detailsWithInsurerId, documentUpload, editAdminResponse, InsurerAgent, insurerStatusCount, lastTenRecords, loginResponse, logins, mappedInsurerProvider, masterProvider, MonthlyData, MonthlyStatus, notifactions, notifications, otpResponse, PatientData, patientResponse, searchPatient, serviceRequestResponse } from '../models/phase1models';
import { DashboardSummary } from '../models/modeladmins';

@Injectable({
  providedIn: 'root'
})


export class MemberInsurerRestService {

  protected ngUnsubscribe: Subject<void> = new Subject<void>();
   private baseUrl = `${environment.apiUrl}/lps`;
    // private baseUrl=`http://localhost:9091`


  constructor(private http: HttpClient, private memberService: MemberInsurerServiceService) { }

  loginUser(reqBody: any) {
    return this.http.post<any>(`${this.baseUrl}/api/auth/login`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  addMember(reqBody: {}) {
    return this.http.post<addMemberResponse>(`${this.baseUrl}/api/insurer/patient/register`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  addAdminInsurer(reqBody: {}) {
    return this.http.post<adminRegister>(`${this.baseUrl}/api/admin/register`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  addAdminsCommon(reqbody: {}) {
    return this.http.post<any>(`${this.baseUrl}/api/admin/users/register `, reqbody).pipe(takeUntil(this.ngUnsubscribe));
  }
  addAdminDisturer(reqBody: {}) {
    return this.http.post<any>(`${this.baseUrl}/api/admin/register`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );

  }
addOrganisation(reqBody:{}){
    return this.http.post<any>(`${this.baseUrl}/api/admin/organisations/register `, reqBody).pipe(takeUntil(this.ngUnsubscribe));

}

editOrganisation(reqBody:{},id:string){
      return this.http.put<any>(`${this.baseUrl}/api/admin/organisations/${id}`, reqBody).pipe(takeUntil(this.ngUnsubscribe));


}


  getAllMails() {
    return this.http.get<any>(`http://localhost:9091/api/admin/allMails`)
  }
  getAllMailsById(id: any) {
    return this.http.get<any>(`http://localhost:9091/api/admin/mailsById/${id}`)
  }

  editAdmins(reqBody: {}, id: string) {
    return this.http.put<any>(`${this.baseUrl}/api/admin/edit-agent/${id}`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }
  editAdminsCommon(reqBody: {}, id: string) {
    return this.http.put<any>(`${this.baseUrl}/api/admin/users/${id}`, reqBody).pipe(takeUntil(this.ngUnsubscribe));
  }

  editMember(reqBody: {}, patientId: string | undefined) {
    return this.http.post<any>(`${this.baseUrl}/api/insurer/editDetails/${patientId}`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  submitMedicalEvidence(formData: FormData, id: string) {
    return this.http.post<documentUpload>(
      `${this.baseUrl}/api/provider/upload/${id}`,
      formData
    ).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }


  requestME(reqBody: {}) {
    return this.http.post<serviceRequestResponse>(`${this.baseUrl}/api/insurer/serviceRequest/create`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  addAgent(reqBody: addAgentPayload) {
    let role = this.memberService.getLoginUserRole();
    if (role == 'INSURER') {
      return this.http.post<addAgent>(`${this.baseUrl}/api/insurer/add-agent`, reqBody).pipe(
        takeUntil(this.ngUnsubscribe)
      );
    }
    else {
      let json = {
        ...reqBody,
        organisationId: this.memberService.getOrg()
      }
      return this.http.post<addAgent>(`${this.baseUrl}/api/providers/add-agent`, json).pipe(
        takeUntil(this.ngUnsubscribe)
      );
    }
  }

  updateAgent(reqBody: Partial<addAgentPayload>, id: string) {
    let role = this.memberService.getLoginUserRole();
    if (role == 'INSURER') {
      return this.http.put<addAgent>(`${this.baseUrl}/api/insurer/edit-agent/${id}`, reqBody).pipe(
        takeUntil(this.ngUnsubscribe)
      );
    }

    return this.http.put<addAgent>(`${this.baseUrl}/api/providers/edit-agent/${id}`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );



    //   else if(role=='distributor'){
    //      return this.http.put<addAgent>(`${this.baseUrl}/api/providers/edit-agent/${id}`, reqBody).pipe(
    //       takeUntil(this.ngUnsubscribe));

    //   }
  }

  updateAgentCommon(reqbody: {}, id: string) {
    return this.http.put<any>(`${this.baseUrl}/api/admin/users/${id}`, reqbody).pipe(takeUntil(this.ngUnsubscribe));

  }

  addProvider(reqBody: FormData) {
    return this.http.post<AddMasterprovider>(
      `${this.baseUrl}/api/masterproviders/add-masterprovider`,
      reqBody
    ).pipe(takeUntil(this.ngUnsubscribe));
  }

  updateProvider(reqBody: Partial<addProviderPayload>, id: string) {
    return this.http.put<any>(
      `${this.baseUrl}/api/masterproviders/update/${id}`,
      reqBody
    ).pipe(takeUntil(this.ngUnsubscribe));
  }


  addProviderAgent(reqBody: {}) {
    return this.http.post<addAgent>(`${this.baseUrl}/api/providers/add-agent`, reqBody).pipe(
      takeUntil(this.ngUnsubscribe)
    );
  }

  getMasterProviders() {
    return this.http.get<masterProvider[]>(`${this.baseUrl}/api/insurer/masterproviders`).pipe(takeUntil(this.ngUnsubscribe))
  }

  getInsurerLast6MonthsData(userId: string) {
    return this.http.get<insurerStatusCount>(`${this.baseUrl}/api/insurer/last-6month/insurer-statuscounts/${userId}`).pipe(takeUntil(this.ngUnsubscribe))
  }

  getDistributorStatusCountsFor6Months(userId: string): Observable<MonthlyStatus[]> {
    return this.http
      .get<MonthlyStatus[]>(`${this.baseUrl}/api/applicants/status-count-for-six-months?userId=${userId}`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }


  getDistributorStatusCounts(userId: string) {
    return this.http.get<insurerStatusCount>(`${this.baseUrl}/api/applicants/status-counts?userId=${userId}`).pipe(takeUntil(this.ngUnsubscribe))
  }

  getAllLatestReqToInsurer() {
    let insurerId = this.memberService.getLoginUserId();
    return this.http.get<lastTenRecords[]>(`${this.baseUrl}/api/insurer/last-10/by-insurer/${insurerId}`).pipe(takeUntil(this.ngUnsubscribe))
  }

  getDashboardDataInsurer(userId: string) {
    return this.http.get<insurerStatusCount>(`${this.baseUrl}/api/insurer/status-count/${userId}`).pipe(takeUntil(this.ngUnsubscribe))
  }

  getDashboardDataProvider(userId: string) {
    return this.http.get<insurerStatusCount>(`${this.baseUrl}/api/providers/status-count/${userId}`).pipe(takeUntil(this.ngUnsubscribe))
  }


  getPatientInformationWithName(name: string) {
    return this.http.get<searchPatient>(`${this.baseUrl}/api/insurer/search?q=${name}`).pipe(takeUntil(this.ngUnsubscribe))
  }

  // getMembersById(id: any) {
  //   return this.http.get<any>(`${this.baseUrl}/lps/getById/${id}`);
  // }

  getAddedProviders(id: any) {
    return this.http.get<any>(`${this.baseUrl}/api/insurer/providerlist/${id}`);

  }

  getMemberById(id: string) {
    console.log('apicalled')
    return this.http.get<PatientData>(`${this.baseUrl}/api/insurer/${id}`)
  }

  searchPatients(searchParam: string) {
    if (searchParam.length >= 3) {
      return this.http.get<any>(`${this.baseUrl}/api/insurer/search`, {
        params: { input: searchParam }
      });
    }
    return of([]);
  }

  getAllMemberList(id: any) {
    let role = this.memberService.getLoginUserRole();
    let orgId = this.memberService.getOrg();
    if (role == 'INSURER')
      return this.http.get<patientResponse[]>(`${this.baseUrl}/api/insurer/agentId/${id}`);
    else
      return this.http.get<any>(`${this.baseUrl}/api/providers/${orgId}/patients`);
  }

  getAllInsurerAgentList(orgid: string) {
    // http://localhost:9091/api/admin/users?orgId=AD3D7D21&role=DISTRIBUTOR
    return this.http.get<adminAgentsData[]>(`${this.baseUrl}/api/admin/users?orgId=${this.memberService.getOrg()}&role=INSURER`);
  }

  getAllProviderAgentList(adminId: string) {
    return this.http.get<adminAgentsData[]>(`${this.baseUrl}/api/admin/providers?adminProviderId=${adminId}`);
  }

  getAllDistributorAgentsList(adminId: String) {
    return this.http.get<any>(`${this.baseUrl}/api/admin/users?orgId=${this.memberService.getOrg()}&role=DISTRIBUTOR`)
  }

  getAllQuestions() {
    return this.http.get<any>('https://lp.dev.healthfirsttech.com/lps/api/questions/all')
  }

  getAllAgentList() {
    let role = this.memberService.getLoginUserRole();
    if (role == 'INSURER')
      http://localhost:9091/api/admin/users?orgId=AD3D7D21&role=DISTRIBUTOR
      return this.http.get<InsurerAgent>(`${this.baseUrl}/api/admin/users?orgId=${this.memberService.getOrg()}&role=INSURER`);
    else
      return this.http.get<any>(`${this.baseUrl}/api/admin/users?orgId=${this.memberService.getOrg()}&role=PROVIDER`);
  }

  getOrganisationName(id: any) {
    return this.http.get<any>(`${this.baseUrl}/api/admin/mapped-insurers/${id}`)
  }

  getprovideragents() {
    let role = this.memberService.getLoginUserRole();
    return this.http.get<any>(`${this.baseUrl}/api/admin/provider-agents?organsationId=${this.memberService.getOrg()}`);

  }


  //   getAllAgentList(): Observable<(InsurerAgent | allAdminInsurerResponse)[]> {
  //   let role = this.memberService.getLoginUserRole();
  //   if (role == 'INSURER') {
  //     // Fetch a single InsurerAgent, then wrap it in an array
  //     return this.http.get<InsurerAgent>(`${this.baseUrl}/lps/api/admin/insurers?adminInsurerId=${this.memberService.getLoginUserId()}`)
  //       .pipe(
  //         map(agent => (agent ? [agent] : [])) // Map single agent to an array containing it, or empty array if null
  //       );
  //   } else {
  //     // Fetch a single allAdminInsurerResponse, then wrap it in an array
  //     return this.http.get<allAdminInsurerResponse>(`${this.baseUrl}/lps/api/admin/provider-agents?organsationId=${this.memberService.getOrg()}`)
  //       .pipe(
  //         map(agent => (agent ? [agent] : [])) // Map single agent to an array containing it, or empty array if null
  //       );
  //   }
  // }

  getAllMasterMEPs(): Observable<masterProvider[]> {
    return this.http.get<masterProvider[]>(`${this.baseUrl}/api/masterproviders`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }

  getadminInsurerMappedProviders(): Observable<any> {
    http://localhost:9091/api/admin/mapped-orgs?orgId=AD3D7D21
    return this.http.get<any>(`${this.baseUrl}/api/admin/mapped-orgs?orgId=${this.memberService.getOrg()}`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }
  getTotalCountsOfAdmins(): Observable<any> {
    return this.http.get<allCounts[]>(`${this.baseUrl}/api/user/roles/count`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }
  getApplicantInfo(id: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/applicants/details?applicantId=${id}`)
  }
  getAllAdminProviders(): Observable<any> {
    return this.http.get<allAdminProviderResponse[]>(`${this.baseUrl}/api/admin?role=ADMIN_PROVIDER`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }

  getProviderOrganisation() {
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=PROVIDER`)


  }

  getAdminById(adminId: string): Observable<any> {
    return this.http.get<any[]>(`${this.baseUrl}/api/admin/${adminId}`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }

  getInsurerOrg() {
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=INSURER`)
  }
  getDistributorOrg() {
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=DISTRIBUTOR`)


  }
  getAllProviderOrganisations(){
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=PROVIDER`)
  }

   getAllInsurerOrganisations(){
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=INSURER`)
  }
  getAllDistributorOrganisations(){
    return this.http.get<any>(`${this.baseUrl}/api/admin/organisations?type=DISTRIBUTOR`)
  }


  getAllAdminInsurers(): Observable<any> {
    return this.http.get<allAdminInsurerResponse[]>(`${this.baseUrl}/api/admin?role=ADMIN_INSURER`)
      .pipe(takeUntil(this.ngUnsubscribe));
  }
  getAllAdminDistributors(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/admin?role=ADMIN_DISTRIBUTOR `)
  }
  getMappedInsurers(adminid: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/admin/ditributor-admin/${adminid}/insurers`)

  }
  saveDraft(reqBody: {}) {
    return this.http.post<any>(`${this.baseUrl}/api/applicants/save-draft`, reqBody)

  }
  submit(reqBody: {}) {
    return this.http.post<any>(`${this.baseUrl}/api/distributor/submit-applicant`, reqBody)
  }
  geneateQuote(reqBody: {}) {
    return this.http.post<any>(`${this.baseUrl}/api/distributor/generatequotation`, reqBody)

  }
  getDistributorApplicants(id: any) {
    // if(acess===''){}

    return this.http.get<any>(`${this.baseUrl}/api/insurer/id/${id}`)
  }
  getInsurerApplicants(id: any) {
    return this.http.get<any>(`${this.baseUrl}/api/insurer/agentId/${id}`)
  }

  emailValidation(body: any) {
    return this.http.post<loginResponse>(`${this.baseUrl}/api/auth/verify-email`, body)

  }

  resetPassword(body: any) {
    return this.http.put<loginResponse>(`${this.baseUrl}/api/auth/reset-password`, body)
  }

  resendOtp(body: any) {
    return this.http.post<loginResponse>(`${this.baseUrl}/api/auth/resend-otp`, body)
  }

  updateAgentStatus(userId: string, status: boolean): Observable<string> {
    const role = this.memberService.getLoginUserRole();

    // let url: `api/admin/users/update-status/{userId} `;
    // if (role === 'INSURER') {
    //   url = `${this.baseUrl}/api/insurer/deactivate/${userId}?status=${status}`;
    // } else {
    //   url = `${this.baseUrl}/api/providers/deactivate-provider/${userId}?status=${status}`;
    // }

    return this.http.put(`${this.baseUrl}/api/admin/users/update-status/${userId}?status=${status} `, {}, { responseType: 'text' });
  }


  updateAdminStatus(userId: string, status: boolean): Observable<string> {
    const role = this.memberService.getLoginUserRole();

    let url = `${this.baseUrl}/api/admin/users/update-status/${userId}?status=${status}`;

    return this.http.put(url, {}, { responseType: 'text' });
  }
updateOrganisationStatus(orgId:string,status:boolean):Observable<string>{
  return this.http.put(`${this.baseUrl}/api/admin/organisations/update-status/${orgId}?status=${status}`,{},{responseType:'text'})  
}

  updateProviderStatus(userId: string, status: boolean) {
    const url = `${this.baseUrl}/api/providers/deactivate/${userId}?status=${status}`;
    return this.http.put(url, {}, { responseType: 'text' });
  }


  updateById(status: string, memberid: number, medicalevidenceid: number) {
    return this.http.post(`${this.baseUrl}/updateStatus`, { status, memberid, medicalevidenceid })
  }

  addMEPtoInsurer(reqBody: {}) {
    return this.http.post(`${this.baseUrl}/api/masterproviders/add-to-providers`, reqBody)
  }

  fillMoreDetails(reqBody: {}, reqId: string) {
    return this.http.post(`${this.baseUrl}/api/insurer/upload/${reqId}`, reqBody)
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    const uploadUrl = `${this.baseUrl}/api/upload/document`;
    return this.http.post<any>(uploadUrl, formData);
  }

  otpverify(inputs: any) {
    return this.http.post<loginResponse>(`${this.baseUrl}/api/auth/verify-otp`, inputs);
  }

  uploadBulkMembers(uploadedFile: File): Observable<any> {
    let insurerId = this.memberService.getLoginUserId();
    const formData = new FormData();
    formData.set('file', uploadedFile, uploadedFile.name);
    console.log(formData);
    return this.http.post<any>(`${this.baseUrl}/api/bulk-upload/document/${insurerId}`, formData)
      .pipe(takeUntil(this.ngUnsubscribe))
  }

  downloadMemberTemplate(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/api/downloadFile?documentPath=https://720016114009-codedeploy-lp-dev.s3.amazonaws.com/template/MemeberTemplate.xlsx`, { responseType: 'blob' });
  }

  getNotificationsForInsurer(userId: string) {
    return this.http.get<notifactions>(`${this.baseUrl}/api/insurer/notifications/${userId}}`);
  }

  getAdminInsurerStacks(userId: any) {
    return this.http.get<DashboardSummary>(
      `${this.baseUrl}/api/insurer/service-request/status-count?orgId=${userId}`
    );
  }

  getDistributorStacks(userId: any) {
    return this.http.get<DashboardSummary>(
      `${this.baseUrl}/api/distributor/service-request/status-count?orgId=${userId}`
    );
  }

  getAdminProviderStacks(id: any) {
    return this.http.get<DashboardSummary>(`${this.baseUrl}/api/providers/service-request/status-count?organisationId=${id}`);
  }

  getNotificationsForProvider(userId: string) {
    return this.http.get<notifications>(`${this.baseUrl}/api/provider/notifications/${userId}`);
  }

  onRequestMoreDeatils(reqBody: {}) {
    return this.http.post<additionalInfoRequest>(`${this.baseUrl}/api/provider/additionalInformation/request`, reqBody)
  }

  makeNotificationRead(notificationId: string) {
    return this.http.get<any>(`${this.baseUrl}/api/provider/notifications/mark-read?id=${notificationId}&read=true`)
  }

  getAgentMappedProviderByInsurer(id: string) {
    return this.http.get<MedicalProvider[]>(`${this.baseUrl}/api/providers/with-insurer-agentid?insurerAgentID=${id}`);
  }

  // getProviderMapppedAgents() {
  //   return this.http.get<any>(`${this.baseUrl}/api/admin/provider-agents?organsationId=${this.memberService.getOrg()}`);
  // }
  getProviderMapppedAgents() {
    return this.http.get<any>(`${this.baseUrl}/api/admin/users?orgId=${this.memberService.getOrg()}&role=PROVIDER`);
  }

  addProviderAgentToRequest(patientId: any, providerId: string) {
    const loginOrg = this.memberService.getOrg();
    return this.http.post(
      `${this.baseUrl}/api/providers/${loginOrg}/assign/${patientId}?assignedProvider=${providerId}`,
      {}, // empty body
      { responseType: 'text' as 'text' } // correctly typed options
    );
  }

  getOrgsByRole(selectedRole:string) {
    return this.http.get<Organisation[]>(`${this.baseUrl}/api/admin/organisations?type=${selectedRole}`);
  }

}
